import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DashboardMenu } from "utils/DashboardMenu";
import { useNavigate } from "react-router-dom";
import { URL_Route } from "urlRouts";
import { Axios_Route } from "API/AxiosRouts";
import Axios, { baseURL } from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { useDispatch } from "react-redux";
import {
  setRoleAction,
  setNameAction,
  setProfilePictureAction,
} from "ReduxSaga/actions/UserActions";
import { useSelector } from "react-redux";

interface Props {
  isDrawerOpen: boolean;
}

const DashboardSideBar: React.FC<Props> = ({ isDrawerOpen }) => {
  const [urlPathname, setUrlPathname] = useState<string>(
    window.location.pathname
  );
  const userStates = useSelector((state: any) => state.userState);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    Axios(AxiosMethodEnum.get, Axios_Route.USER_INFO).then(
      ({ response, success }) => {
        if (success) {
          dispatch(setNameAction(response.fullName));
          dispatch(setRoleAction(response.roleName));
          dispatch(setProfilePictureAction(response.imageUrl));
        }
      }
    );
  }, []);

  useEffect(() => {
    setUrlPathname(window.location.pathname);
  }, [navigate]);

  return (
    <>
      <div
        className={`sidebar-main-parent ${
          isDrawerOpen ? "openedDrawer" : "closedDrawer"
        }`}
      >
        <img
          className="profile-picture"
          src={baseURL + userStates.profilePicture}
        />
        <p className="profile-name">{userStates.name}</p>
        <p className="profile-position">{userStates.role}</p>
        <div className="drawer-items-parent">
          {DashboardMenu.map((item, key) =>
            urlPathname === "/" + item.link ||
            urlPathname === item.link ||
            urlPathname === item.link + "/" ||
            urlPathname === "/" + item.link + "/" ? (
              <Link key={key} to={item.link}>
                <div className="drawer-menu-items current-page">
                  <img src={item.activeIcon} />
                  <p>{item.text}</p>
                </div>
              </Link>
            ) : item.link === URL_Route.Log_Out ? (
              <Link key={key} to={item.link}>
                <div className="drawer-menu-items exit-profile">
                  <img src={item.defaultIcon} />
                  <p>{item.text}</p>
                </div>
              </Link>
            ) : userStates.role === "Advisor" ? (
              item.id === "panel" ||
              item.id === "propertyList" ||
              item.id === "addProperty" ? (
                <Link key={key} to={item.link}>
                  <div className="drawer-menu-items">
                    <img src={item.defaultIcon} />
                    <p>{item.text}</p>
                  </div>
                </Link>
              ) : (
                <div key={key}></div>
              )
            ) : userStates.role === "Admin" ? (
              <Link key={key} to={item.link}>
                <div className="drawer-menu-items">
                  <img src={item.defaultIcon} />
                  <p>{item.text}</p>
                </div>
              </Link>
            ) : userStates.role === "Operator" ? (
              item.id === "panel" ||
              item.id === "propertyList" ||
              item.id === "addProperty" ? (
                <Link key={key} to={item.link}>
                  <div className="drawer-menu-items">
                    <img src={item.defaultIcon} />
                    <p>{item.text}</p>
                  </div>
                </Link>
              ) : (
                <div key={key}></div>
              )
            ) : (
              <div key={key}></div>
            )
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardSideBar;
